import React from 'react';
import { FaEye, FaFlag, FaBullseye } from 'react-icons/fa';
import DeleteButton from '../editors/DeleteButton';

interface VisionMissionCard {
  icon: string;
  titleAr: string;
  titleEn: string;
  descAr: string;
  descEn: string;
  bg: string;
}

interface VisionMissionSectionProps {
  language?: 'ar' | 'en';
  cards?: VisionMissionCard[];
  onDeleteCard?: (index: number) => void;
}

const VisionMissionSection: React.FC<VisionMissionSectionProps> = ({ 
  language = 'ar',
  cards = [
    {
      icon: 'FaEye',
      titleAr: 'رؤيتنا',
      titleEn: 'Our Vision',
      descAr: 'أن نكون روادًا في مجال المقاولات ونحقق التميز في جميع مشاريعنا.',
      descEn: 'To be pioneers in the construction field and achieve excellence in all our projects.',
      bg: 'bg-blue-50',
    },
    {
      icon: 'FaFlag',
      titleAr: 'رسالتنا',
      titleEn: 'Our Mission',
      descAr: 'تقديم خدمات عالية الجودة تلبي تطلعات عملائنا وتحقق التنمية المستدامة.',
      descEn: 'To provide high-quality services that meet our clients\' aspirations and achieve sustainable development.',
      bg: 'bg-green-50',
    },
    {
      icon: 'FaBullseye',
      titleAr: 'أهدافنا',
      titleEn: 'Our Goals',
      descAr: 'الابتكار، الجودة، والالتزام بمواعيد التسليم لتحقيق رضا العملاء.',
      descEn: 'Innovation, quality, and on-time delivery to achieve customer satisfaction.',
      bg: 'bg-orange-50',
    },
  ],
  onDeleteCard
}) => {
  const isRTL = language === 'ar';

  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case 'FaEye': return FaEye;
      case 'FaFlag': return FaFlag;
      case 'FaBullseye': return FaBullseye;
      default: return FaEye;
    }
  };

  return (
    <section
      className={`section-padding ${isRTL ? 'font-cairo' : 'font-montserrat'}`}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            {language === 'ar' ? 'الرؤية والرسالة والأهداف' : 'Vision, Mission & Goals'}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card, idx) => {
            const IconComponent = getIconComponent(card.icon);
            return (
              <div
                key={idx}
                className={`group relative flex flex-col items-center text-center rounded-2xl p-8 shadow-md transition hover:shadow-xl ${card.bg}`}
              >
                {onDeleteCard && (
                  <DeleteButton onDelete={() => onDeleteCard(idx)} />
                )}
                <div className="flex items-center justify-center w-20 h-20 rounded-full bg-white shadow mb-4">
                  <IconComponent className="w-10 h-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {isRTL ? card.titleAr : card.titleEn}
                </h3>
                <p className="text-gray-600 text-base">
                  {isRTL ? card.descAr : card.descEn}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VisionMissionSection; 